import { useEffect, useState } from "react";
/** MUI */
import { Button } from "@mui/material";
/** redux */
import { getPrediction } from "@/src/_appStore/DB_Common";
import { useSelector } from "react-redux";
/** Helpers */
import { useTranslation } from "react-i18next";

const ApplyButton = (props) => {
    const { JTS_NEW, JTS_SNAPSHOT, handleApply } = props;
    const { t } = useTranslation();

    /** states */
    const [DISAPPLY, setDISAPPLY] = useState(false);
    /** - redux */
    const prediction = useSelector(getPrediction);

    /** effects */
    useEffect(() => {
        const _dn = structuredClone(JTS_NEW);
        const _dns = structuredClone(JTS_SNAPSHOT);
        const _disapply =
            JSON.stringify([...(_dn || [])]?.map((a) => a?.id)?.sort((a, b) => a.localeCompare(b))) ===
            JSON.stringify([...(_dns || [])]?.map((a) => a?.id)?.sort((a, b) => a.localeCompare(b)));

        setDISAPPLY(!JTS_NEW?.length || _disapply || !!prediction?.table?._errMessageShort);
    }, [JTS_SNAPSHOT, JTS_NEW, prediction]);

    return (
        <>
            <Button onClick={handleApply} color={"primary"} size={"small"} disabled={DISAPPLY}>
                {t("Zatwierdź")}
            </Button>
        </>
    );
};

export default ApplyButton;
